import IMask from 'imask'

export const phonePipe = IMask.createPipe({
  mask: '+{7} (000)000-00-00',
})

export const renderPhone = (phone: string) => phonePipe(phone.slice(1))
